/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_New_Guide_CreatedInputs */

const en_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New KNP guide created`)
};

const fr_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau guide KNP créé`)
};

const de_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer KNP-Führer erstellt`)
};

const it_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creata la nuova guida KNP`)
};

const ru_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создан новый путеводитель по КНП.`)
};

const es_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva guía del KNP creada`)
};

const zh_cn2_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新版克鲁格国家公园指南已编写完成`)
};

const ja_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいKNPガイドが作成されました`)
};

const hi_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी के लिए नई गाइड बनाई गई`)
};

const pt_pt2_knp_manager_new_guide_created = /** @type {(inputs: Knp_Manager_New_Guide_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo guia do KNP criado`)
};

/**
* | output |
* | --- |
* | "New KNP guide created" |
*
* @param {Knp_Manager_New_Guide_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_new_guide_created = /** @type {((inputs?: Knp_Manager_New_Guide_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_New_Guide_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_new_guide_created(inputs)
	if (locale === "de") return de_knp_manager_new_guide_created(inputs)
	if (locale === "it") return it_knp_manager_new_guide_created(inputs)
	if (locale === "ru") return ru_knp_manager_new_guide_created(inputs)
	if (locale === "es") return es_knp_manager_new_guide_created(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_new_guide_created(inputs)
	if (locale === "ja") return ja_knp_manager_new_guide_created(inputs)
	if (locale === "hi") return hi_knp_manager_new_guide_created(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_new_guide_created(inputs)
	return en_knp_manager_new_guide_created(inputs)
});